import { useSelector } from 'react-redux';
import type { RootState } from '../redux/store';
import HelpSidebar from '../components/HelpSidebar';
import Navbar from "../components/Navbar";
import DealerLayout from "./DealerLayout";
import { PortalFeedbackProvider } from "../context/PortalFeedbackContext";
import PortalFeedbackModal from "../components/feedback/PortalFeedbackModal";
import SpotfixWidget from "../components/SpotfixWidget";

export default function DealerWrapper() {
  const { spotfixToken, user } = useSelector((state: RootState) => state.auth);
  const activeSpotfixToken = spotfixToken || user?.spotfixToken || localStorage.getItem("spotfix_token");

  return (
    <PortalFeedbackProvider>
      <div className="flex flex-col h-screen overflow-hidden bg-gray-50">
        <div className="flex-none z-50 relative">
          <Navbar />
        </div>
        <div className="flex-1 overflow-hidden relative">
          <DealerLayout />
        </div>
      </div>
      <PortalFeedbackModal />
      <HelpSidebar />
      <SpotfixWidget userToken={activeSpotfixToken} />
    </PortalFeedbackProvider>
  ); 
}
